<template>
  <div id="app" v-cloak>
    <template v-if="isAuthRoute">
      <router-view />
    </template>
    <template v-else-if="isHomePouter">
        <el-header>
          <app-header />
        </el-header>
        <!-- 主要内容 -->
        <el-main>
          <router-view />
        </el-main>
    </template>
    <template v-else>
      <el-container>
        <!-- 头部 -->
        <el-header>
          <app-header />
        </el-header>
        
        <!-- 主要内容 -->
        <el-main>
          <router-view />
        </el-main>
        
        <!-- 底部 -->
        <!-- <el-footer>
          <app-footer />
        </el-footer> -->
      </el-container>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from '@/components/layout/AppHeader.vue'
// import AppFooter from '@/components/layout/AppFooter.vue'
import 'animate.css'

export default {
  name: 'App',
  components: {
    AppHeader,
    // AppFooter
  },

  setup() {
    const route = useRoute();

    const isAuthRoute = computed(() => {
      // 根据路由路径判断是否是认证相关路由
      // 假设所有认证路由都在 /auth/ 下
      return route.path.startsWith('/auth');
      // 或者，如果您在路由元信息中添加了一个标记 (推荐)
      // return route.meta.layout === 'auth';
    });

    const isHomePouter = computed(() => {
      return route.path.startsWith('/home') || route.path.startsWith('/shoes') || route.path.startsWith('/article') || route.path.startsWith('/overview');
    });

    return {
      isAuthRoute,
      isHomePouter
    };
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}

#app {
  height: 100%;
}

/* 隱藏未翻譯的內容，直到Vue載入完成 */
[v-cloak] {
  display: none;
}

.el-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-main {
  flex: 1;
  padding: 0px !important;
}

.el-header {
  padding: 0 !important;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.el-footer {
  // background-color: #f7f7f7;
  padding: 20px 0;
  margin-top: auto;
}
</style> 